<template>
  <div class="financial-statement-item">
    <col-table :data="tableData" :pageSize="pageSize" :class="{ 'col-table--same': isSame, 'table-var': true }">
      <col-table-column label="日期" prop="endDate" :css="{ height: '50px' }">
        <template #header>
          <div class="date-header">
            <span>报告期<i class="iconfont icon-wenhao ml-4px" @click="popupVisible = true"></i></span>
            <span class="tongbi">
              {{ $t('同比')
              }}<span class="checkbox-wrap"><input type="checkbox" v-model="isSame" class="checkbox" /></span>
            </span>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ scope.row.sortYear + scope.row.reportType }}</span>
            <span class="scale">{{ $t('同比') }}</span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="coverMonths" label="覆盖时期(月)">
        <template slot-scope="scope">{{ $digitjs(scope.row[formatAParams('coverMonths')]).isNull() }}</template>
      </col-table-column>
      <col-table-column prop="currency" label="报表货币" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">{{ $digitjs(scope.row[formatAParams('currency')]).isNull() }}</template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>经营活动现金流量</template>
      </col-table-column>
      <col-table-column prop="cashFlowFromOperations" label="经营业务之现金流量">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('cashFlowFromOperations')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('cashFlowFromOperationsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('cashFlowFromOperationsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="disposalFixedAssets" label="出售固定资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('disposalFixedAssets')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('disposalFixedAssetsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('disposalFixedAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="taxesPaidOrRefunded" label="退回/(已缴)税项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('taxesPaidOrRefunded')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('taxesPaidOrRefundedYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('taxesPaidOrRefundedYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netCashFromOperating" label="经营业务产生之现金净额" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netCashFromOperating')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('netCashFromOperatingYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('netCashFromOperatingYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>投资活动现金流量</template>
      </col-table-column>
      <col-table-column prop="interestReceived" label="已收利息">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('interestReceived')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('interestReceivedYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('interestReceivedYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="dividendReceived" label="已收股息">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('dividendReceived')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('dividendReceivedYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('dividendReceivedYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="othersReturnOnInvest" label="其他(投资回报)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('othersReturnOnInvest')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('othersReturnOnInvestYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('othersReturnOnInvestYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netCashFlowFromInvestAndFin" label="投资回报及融资费用之现金流量">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netCashFlowFromInvestAndFin')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('netCashFlowFromInvestAndFinYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('netCashFlowFromInvestAndFinYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="additionsFixedAssets" label="增添固定资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('additionsFixedAssets')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('additionsFixedAssetsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('additionsFixedAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="increaseInvestments" label="投资增加">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('increaseInvestments')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('increaseInvestmentsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('increaseInvestmentsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="decreaseInvestments" label="投资减少">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('decreaseInvestments')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('decreaseInvestmentsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('decreaseInvestmentsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="cashFromRelatedPartiesOfInvest" label="关连人士现金流量(投资活动)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{
              $digitjs(scope.row[formatAParams('cashFromRelatedPartiesOfInvest')]).convert()
            }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('cashFromRelatedPartiesOfInvestYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('cashFromRelatedPartiesOfInvestYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="othersInvestingActivities" label="其他(投资活动)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('othersInvestingActivities')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('othersInvestingActivitiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('othersInvestingActivitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netCashFromInvesting" label="投资业务产生之现金净额" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netCashFromInvesting')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('netCashFromInvestingYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('netCashFromInvestingYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>融资活动现金流量</template>
      </col-table-column>
      <col-table-column prop="netCashFromFinancing" label="融资业务产生之现金净额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netCashFromFinancing')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('netCashFromFinancingYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('netCashFromFinancingYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="interestPaid" label="已付利息">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('interestPaid')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('interestPaidYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('interestPaidYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="dividendPaid" label="已派股息">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('dividendPaid')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('dividendPaidYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('dividendPaidYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="newLoans" label="新增贷款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('newLoans')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('newLoansYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('newLoansYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="loansRepayment" label="偿还贷款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('loansRepayment')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('loansRepaymentYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('loansRepaymentYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="debtFinancing" label="定息/债项工具融资">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('debtFinancing')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('debtFinancingYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('debtFinancingYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="equityFinancing" label="股本融资">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('equityFinancing')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('equityFinancingYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('equityFinancingYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="cashFromRelatedPartiesOfFin" label="关连人士现金流量(融资活动)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('cashFromRelatedPartiesOfFin')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('cashFromRelatedPartiesOfFinYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('cashFromRelatedPartiesOfFinYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="redemptionDebtInstruments" label="偿还定息/债项工具">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('redemptionDebtInstruments')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('redemptionDebtInstrumentsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('redemptionDebtInstrumentsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="othersFinancingActivities" label="其他(融资活动)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('othersFinancingActivities')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('othersFinancingActivitiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('othersFinancingActivitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="changeInCapitalStock" label="已发行股本变动(股)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('changeInCapitalStock')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('changeInCapitalStockYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('changeInCapitalStockYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="cashDividendsPaid" label="发放现金股利" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('cashDividendsPaid')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('cashDividendsPaidYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('cashDividendsPaidYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>现金及现金等价物</template>
      </col-table-column>
      <col-table-column prop="cashAtEndYear" label="年终之现金及等同现金项目">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('cashAtEndYear')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('cashAtEndYearYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('cashAtEndYearYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="cashAtBeginningYear" label="年初之现金及等同现金项目">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('cashAtBeginningYear')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('cashAtBeginningYearYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('cashAtBeginningYearYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netIncreaseInCash" label="现金及等同现金之增加/(减少)净额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netIncreaseInCash')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('netIncreaseInCashYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('netIncreaseInCashYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="exchangeRateEffect" label="外币汇率变动之影响/其他">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('exchangeRateEffect')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('exchangeRateEffectYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('exchangeRateEffectYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
    </col-table>
    <RkPopup :visible.sync="popupVisible"><ReportSheetPrompt /></RkPopup>
  </div>
</template>

<script>
import RkPopup from '@/components/common/Popup.vue'
import ReportSheetPrompt from '@/components/common/ReportSheetPrompt.vue'
export default {
  components: { RkPopup, ReportSheetPrompt },
  props: ['css'],
  data() {
    return {
      isSame: false,
      popupVisible: false,
      tableData: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    pageSize() {
      return this.isSame ? 1 : 2
    }
  },
  created() {
    this.getCashStatement()
  },
  methods: {
    // 将A股同义字段统一为港股接口字段名称
    formatAParams(val) {
      if (this.market !== 'hs') return val

      const oldVal = val.replace('YoY', '')

      const newVal = {
        // 经营业务之现金流量
        cashFlowFromOperations: '',
        // 出售固定资产
        disposalFixedAssets: 'netCashRecDispFIAsset',
        // 退回/(已缴)税项
        taxesPaidOrRefunded: '',
        // 经营业务产生之现金净额
        netCashFromOperating: 'netCashFlowOper',
        // 已收利息
        interestReceived: '',
        // 已收股息
        dividendReceived: '',
        // 其他(投资回报)
        othersReturnOnInvest: '',
        // 投资回报及融资费用之现金流量
        netCashFlowFromInvestAndFin: '',
        // 增添固定资产
        additionsFixedAssets: '',
        // 投资增加
        increaseInvestments: '',
        // 投资减少
        decreaseInvestments: '',
        // 关连人士现金流量(投资活动)
        cashFromRelatedPartiesOfInvest: '',
        // 其他(投资活动)
        othersInvestingActivities: '',
        // 投资业务产生之现金净额
        netCashFromInvesting: '',
        // 融资业务产生之现金净额
        netCashFromFinancing: '',
        // 已付利息
        interestPaid: '',
        // 已派股息
        dividendPaid: '',
        // 新增贷款
        newLoans: '',
        // 偿还贷款
        loansRepayment: 'debtRepay',
        // 定息/债项工具融资
        debtFinancing: '',
        // 股本融资
        equityFinancing: '',
        // 关连人士现金流量(融资活动)
        cashFromRelatedPartiesOfFin: '',
        // 偿还定息/债项工具
        redemptionDebtInstruments: '',
        // 其他(融资活动)
        othersFinancingActivities: '',
        // 已发行股本变动(股)
        changeInCapitalStock: '',
        // 发放现金股利
        cashDividendsPaid: 'cashPaidDiviProfInte',
        // 年终之现金及等同现金项目
        cashAtEndYear: 'cashEquiEnding',
        // 年初之现金及等同现金项目
        cashAtBeginningYear: 'cashEquiBeginning',
        // 现金及等同现金之增加/(减少)净额
        netIncreaseInCash: 'cashEquiNetIncr',
        // 外币汇率变动之影响/其他
        exchangeRateEffect: 'effectForeignExRate'
      }[oldVal]

      return newVal ? val.replace(oldVal, newVal) : val
    },
    // 将A股值不同的字段统一为港股接口字段值
    formatAVal(val, type = 'reportType') {
      return (
        {
          reportType: {
            12: 'F',
            9: 'Q3',
            6: 'I',
            1: 'Q1'
          },
          currency: {
            142: 'RMB'
          }
        }?.[type]?.[val] ?? val
      )
    },
    async getCashStatement() {
      const res = await this.$post(this.$api.f10[this.market] + '/finance/cash', {
        symbol: this.symbol,
        startDate: this.$dayjs().subtract(5, 'year').format('YYYY-MM-DD')
      })
      const reportTypeMap = {
        F: 4,
        Q3: 3,
        I: 2,
        Q1: 1
      }

      let data = res.data?.filter((item) => Boolean(reportTypeMap[this.formatAVal(item.reportType)])) ?? []

      data = data.map((item) => {
        item.sortYear = +this.$dayjs(item.reportDate).format('YYYY')
        item.reportType = this.formatAVal(item.reportType)
        item.currency = this.formatAVal(item.currency, 'currency')
        return item
      })

      this.tableData = data.sort(
        (a, b) => b.sortYear - a.sortYear || reportTypeMap[b.reportType] - reportTypeMap[a.reportType]
      )
    }
  }
}
</script>

<style lang="scss">
.financial-statements-hk {
}
</style>
